export default "__VITE_ASSET__BuW1X$9S__"